/* eslint-disable prettier/prettier */

export const incomeConstants = {
    FETCHING_LEVEL_INCOME_API_SUCCESS: 'FETCHING_LEVEL_INCOME_API_SUCCESS',
    FETCHING_LEVEL_INCOME_API_FAILED: 'FETCHING_LEVEL_INCOME_API_FAILED',
    FETCHING_REWARD_INCOME_API_SUCCESS: 'FETCHING_REWARD_INCOME_API_SUCCESS',
    FETCHING_REWARD_INCOME_API_FAILED: 'FETCHING_REWARD_INCOME_API_FAILED',
    FETCHING_TASK_INCOME_API_SUCCESS: 'FETCHING_TASK_INCOME_API_SUCCESS',
    FETCHING_TASK_INCOME_API_FAILED: 'FETCHING_TASK_INCOME_API_FAILED',
}